import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-select-provinces',
  templateUrl: './select-provinces.component.html',
  styleUrls: ['./select-provinces.component.scss'],
})
export class SelectProvincesComponent implements OnInit {

  @Input() provinces : any[] = [];

  search : string;
  dataOriginal : any[] = [];
  firstIntent : number = 0;
  value : string;


  constructor(private modalController : ModalController) { }

  ngOnInit() {}

  searching() {

    console.log(this.provinces)
    if(this.firstIntent == 0) {
      this.dataOriginal = this.provinces;
      this.firstIntent ++;
    }
    if(!this.search || this.search == "") return this.provinces = this.dataOriginal
    else this.provinces = this.provinces.filter((item) => item.province.includes(this.search.toUpperCase()) )
  }

  async saveData(){
    const modal = await this.modalController.getTop();
    if(modal) {
      this.modalController.dismiss({
        dataSelected : this.value
      })
    }
    
  }

}
